import _ from 'lodash';
import {Model, ARRAY_SHAPE, DOCUMENT_SHAPE} from 'vias';
import http from 'sp-components/util/http';
import {routes, url} from 'oo-routes';

export default new Model('MockupTemplate', {
  id: '_id',
}, {
  get: function (alias, key, options, cb) {
    http.get(url('query', routes.query.mockupTemplate.base, {mockupTemplateId: key}), cb);
  },
},{
  searchByIdentifier: {
    shape: DOCUMENT_SHAPE,
    action(data, options, cb) {
      http.get(url('query', routes.query.mockupTemplate.byIdentifier, {identifier: data}), cb);
    },
  },
});



// WEBPACK FOOTER //
// ./~/sp-components/models/MockupTemplate.js